"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Emitter_1 = __importDefault(require("licia/Emitter"));
var each_1 = __importDefault(require("licia/each"));
var Observer = (function (_super) {
    __extends(Observer, _super);
    function Observer() {
        var _this = _super.call(this) || this;
        _this.observer = new MutationObserver(function (mutations) {
            each_1.default(mutations, function (mutation) { return _this.handleMutation(mutation); });
        });
        return _this;
    }
    Observer.prototype.observe = function () {
        var observer = this.observer;
        observer.disconnect();
        observer.observe(document.documentElement, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true,
        });
    };
    Observer.prototype.handleMutation = function (mutation) {
        if (mutation.type === 'attributes') {
            this.emit('attributes', mutation.target, mutation.attributeName);
        }
        else if (mutation.type === 'childList') {
            this.emit('childList', mutation.target, mutation.addedNodes, mutation.removedNodes);
        }
        else if (mutation.type === 'characterData') {
            this.emit('characterData', mutation.target);
        }
    };
    return Observer;
}(Emitter_1.default));
exports.default = new Observer();
